export default __webpack_public_path__ + "static/media/009-diploma.d90e1c38.svg";